import { render } from "./DepositsNotSent.vue?vue&type=template&id=310a4aae&scoped=true"
import script from "./DepositsNotSent.vue?vue&type=script&lang=js"
export * from "./DepositsNotSent.vue?vue&type=script&lang=js"

import "./DepositsNotSent.vue?vue&type=style&index=0&id=310a4aae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310a4aae"]])

export default __exports__